import { FC } from 'react';
import Link from 'next/link';
import RetellingSticker from '@/components/ui/retelling-sticker/RetellingSticker';
import { parseISO, format } from 'date-fns';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';
import { getTruncatedTxt } from '@/helpers/helpers';
import styles from './RetellingCard.module.scss';

interface IRetellingCardProps {
  book_alias: string;
  external_id: number;
  created_at: string;
  description: string;
  title: string;
  rating: number;
  reviews_count: number;
  author_name: string;
  author_alias: string;
}

const RetellingCard: FC<IRetellingCardProps> = ({ book_alias, author_alias, external_id, created_at, description, title, rating, reviews_count, author_name }) => {
  const bookLink = `/avtor/${author_alias}/${book_alias}/`;
  const authorLink = `/avtor/${author_alias}/`;

  return (
    <div className={styles.retellingCard}>
      <div className={styles.retellingCard__item}>
        <Link prefetch={false} href={bookLink} className={styles.retellingCard__imgLink}>
          <img src={`${DEV_ABSOLUTE_URL}/covers_200/${external_id}.jpg`} alt="Книга" className={styles.retellingCard__img} />
          <RetellingSticker />
        </Link>

        <div className={styles.retellingCard__desc}>
          <div className={styles.retellingCard__info}>
            <Link prefetch={false} href={bookLink} className={`${styles.retellingCard__imgLink} ${styles.retellingCard__imgLink_mob}`}>
              <img src={`${DEV_ABSOLUTE_URL}/covers_100/${external_id}.jpg`} alt="Книга" className={`${styles.retellingCard__img} ${styles.retellingCard__imgMob}`} />
            </Link>

            <div className={styles.retellingCard__infoWrap}>
              <ul className={styles.retellingCard__stats}>
                <li className={styles.retellingCard__date}>
                  <time dateTime={created_at}>{format(parseISO(created_at), 'dd.MM.yyyy')}</time>
                </li>
                <li className={styles.retellingCard__rating}>{rating}</li>
                <li className={styles.retellingCard__reviews}>{reviews_count}</li>
              </ul>
              <Link prefetch={false} href={bookLink} className={styles.retellingCard__title}>
                {title}
              </Link>
              <Link prefetch={false} href={authorLink} className={styles.retellingCard__author}>
                {author_name}
              </Link>
            </div>
          </div>

          <div className={styles.retellingCard__txt}>{getTruncatedTxt(description, 290)}</div>
          <Link prefetch={false} className={styles.retellingCard__btn} href={bookLink}>
            Подробнее
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RetellingCard;
